//* Libraries imports
import z from "zod";

export const laravelPaginationLinksSchema = z.array(
  z.object({
    url: z.string().nullable(),
    label: z.string(),
    active: z.boolean(),
  })
);

export type LaravelPaginationLinks = z.infer<typeof laravelPaginationLinksSchema>;

export const laravelPaginationMetaSchema = z.object({
  currentPage: z.number(),
  totalPages: z.number(),
  itemsPerPage: z.number(),
  totalItems: z.number(),
});

export type LaravelPaginationMeta = z.infer<typeof laravelPaginationMetaSchema>;

/**
 * Generates a schema for paginated data that comes from the Laravel API.
 * 
 * It uses the default Laravel pagination structure.
 */

export function generatePaginatedDataSchema<T extends z.ZodType<z.infer<T>>>(schema: T) {
  const data = z.array(schema);

  return z.object({
    data,
    pagination: laravelPaginationMetaSchema,
  })
}
